import { render } from "./MemberMaxCap.vue?vue&type=template&id=d2970f3e&scoped=true"
import script from "./MemberMaxCap.vue?vue&type=script&lang=js"
export * from "./MemberMaxCap.vue?vue&type=script&lang=js"

import "./MemberMaxCap.vue?vue&type=style&index=0&id=d2970f3e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2970f3e"]])

export default __exports__